import { Modal, Spinner } from 'reactstrap'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { toast } from 'react-toastify';
import InlineSpinner from '../../components/Loaders/InlineSpinner';

export default function ArticleModal({ isOpen, onClose }) {
    // Initialize React Hook Form
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset
    } = useForm();
    const [loading, setLoading] = useState(false)

    // Handle form submission
    const onSubmit = async (data) => {
        const postData = {
            mailId: data?.email,
            firstName: data?.firstName,
            lastName: data?.lastName,
            contact: data?.phone
        }
        try {
            const option = {
                method: 'POST',
                data: postData
            }
            setLoading(true)
            const res = await callApi(apiUrl.add_mail, option);
            if (res?.status === true) {
                setLoading(false)
                toast.success(res?.message);
                reset();
                onClose();
            } else {
                setLoading(false)
                toast.error(res?.message)
            }
        } catch (err) {
            setLoading(false)
            // console.log(err);
        }
    };
    return (
        <Modal className="modal-dialog modal-lg articlemodal" id="exampleModal" isOpen={isOpen} toggle={() => {
            onClose();
            reset();
        }}>
            <div className="modal-content position-relative">
                <button type="button" className="close" onClick={() => {
                    onClose();
                    reset();
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
                <div className="modal-body p-0">
                    <div className='article-modal-body position-relative'>
                        <div className='img-box'>
                            <img className='w-100' src={`${process.env.PUBLIC_URL}/assets/images/MyBiltyBanner.png`} alt="anim_line" />
                            {/* <img className='w-100' src="./" alt="" /> */}
                        </div>
                        <div className='article_bottomcon'>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="newsnewmodal p-3">
                                    <div className="headercon">
                                        <h3 className="text-white">Subscribe to MyBilty's Newsletters</h3>
                                        <p className="text-white">
                                            Get exclusive updates, tips, and insights to streamline your online bilty creation and lorry receipt management. Be the first to know about new features, offers, and industry news!
                                        </p>
                                    </div>
                                    <div className="modcontent text-white text-left">
                                        <div className="row">
                                            <div className="col-12 mb-3 col-lg-6">
                                                <label htmlFor="firstName" className="form-label">First name</label>
                                                <input
                                                    type="text"
                                                    id="firstName"
                                                    className="form-control"
                                                    {...register('firstName', { required: 'First name is required' })}
                                                />
                                                {errors.firstName && (
                                                    <p className="text-danger">{errors.firstName.message}</p>
                                                )}
                                            </div>
                                            <div className="col-12 mb-3 col-lg-6">
                                                <label htmlFor="lastName" className="form-label">Last name</label>
                                                <input
                                                    type="text"
                                                    id="lastName"
                                                    className="form-control"
                                                    {...register('lastName', { required: 'Last name is required' })}
                                                />
                                                {errors.lastName && (
                                                    <p className="text-danger">{errors.lastName.message}</p>
                                                )}
                                            </div>
                                            <div className="col-12 mb-3 col-lg-6">
                                                <label htmlFor="email" className="form-label">Email address</label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    className="form-control"
                                                    {...register('email', {
                                                        required: 'Email is required',
                                                        pattern: {
                                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                            message: 'Invalid email address',
                                                        },
                                                    })}
                                                />
                                                {errors.email && (
                                                    <p className="text-danger">{errors.email.message}</p>
                                                )}
                                            </div>
                                            <div className="col-12 mb-3 col-lg-6">
                                                <label htmlFor="phone" className="form-label">Phone</label>
                                                <input
                                                    type="text"
                                                    id="phone"
                                                    className="form-control"
                                                    {...register('phone', {
                                                        required: 'Phone number is required',
                                                        pattern: {
                                                            value: /^[0-9]{10}$/,
                                                            message: 'Phone number must be 10 digits',
                                                        },
                                                    })}
                                                />
                                                {errors.phone && (
                                                    <p className="text-danger">{errors.phone.message}</p>
                                                )}
                                            </div>
                                            <div className="col-12 mt-2">
                                                <button
                                                    className="btn btn-primary px-4 py-2 rounded-0"
                                                    type="submit"
                                                >
                                                    {loading ? <InlineSpinner /> : "Subscribe"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </Modal>
    )
}
